<div class="channel__reminder contact-info-warn" fxLayout="column" fxLayoutGap="8px">
  <span i18n>You'll be able to share contact information after the booking has been signed.</span>
  <div>
    <button class="gig-button primary" (click)="acknowledge()" i18n>I understand</button>
  </div>
</div>
